module.exports = __webpack_public_path__ + "img/digitalIdentity5.1ef23e01.png";